import "./ProductTypePills.css";

export const PRODUCT_TYPES = ["Flower", "Edibles", "Concentrates", "Drinks", "Vapes", "Other"];

// Shared multi-select control for the product types traded with a supply-chain partner —
// used by SupplyChainPartners/PartnerEntry (Registration, Settings, Admin) so the enum and
// pill styling stay in one place. Enum mirrors constants/supplyChain.js PRODUCT_TYPES.
export default function ProductTypePills({ selected = [], onToggle, disabled = false }) {
    return (
        <div className="product-type-pills">
            {PRODUCT_TYPES.map((type) => {
                const isSelected = selected.includes(type);
                return (
                    <button
                        type="button"
                        key={type}
                        disabled={disabled}
                        className={`product-type-pill${isSelected ? " product-type-pill--active" : ""}`}
                        onClick={() => onToggle(type)}
                        aria-pressed={isSelected}
                    >
                        {type}
                    </button>
                );
            })}
        </div>
    );
}
